export default __webpack_public_path__ + "static/image-fylo-2col-landing-page-f491a5ac337b3027cb7180ce688d548f.png";